<script>
   /*************************************************************/
   /* Widget for Savitzky-Golay                                 */
   /* -----------------------------------                       */
   /*************************************************************/

   import { Container, Select, RangeDiscrete } from 'svelte-controls-basic';
   import PrepTemplate from './PrepTemplate.svelte';


   let {
      params = $bindable([3, 1, 0]),
      settings = $bindable(),
      left,
      right,
      nvars,
      ...others
   } = $props();

   // prefix for the label ids the controls below are named by, unique per widget instance
   const uid = $props.id();


   // the C side refuses a filter wider than the data it runs on, and "left" and "right" are the
   // interval as of this method's position in the chain, so a trim ahead of it counts (see the
   // degree in 'PrepBaseline'). odd, at most 39, and never below 3, the smallest filter there is
   const maxWidth = $derived.by(() => {
      const n = Number.isFinite(right - left) ? right - left : (nvars || 0);
      const v = Math.min(39, Math.round(n * 0.25));
      return Math.max(3, v % 2 < 1 ? v + 1 : v);
   });

   // effect to pull the width down when the data cannot carry it: "params[0]" arrives from a
   // saved model, or from a trim ahead of it edited or moved, so it can already sit above the bound
   $effect(() => {
      if (params[0] > maxWidth) params[0] = maxWidth;
   });

   // derive options for derivative and polynomial
   const derOptions = $derived(params[1] < 2 ? [0, 1] : [0, 1, 2]);
   const polOptions = $derived(params[0] < 5 ? [1, 2] : [1, 2, 3]);

   // adjust polynomial if filter width is too small
   $effect(() => {
      if (params[0] < 5 && params[1] > 2) params[1] = 2;
   });

   // adjust derivative if polynomial is too small
   $effect(() => {
      if (params[2] > params[1]) params[2] = params[1];
   });

   $effect(() => {
      settings = params[0] + ', ' + params[1] + ', ' + params[2];
   });

   const title = 'Savitzky-Golay';

</script>


<PrepTemplate {title} {settings} {...others}>
   <Container label="Width" id="{uid}-width">
   <RangeDiscrete bind:value={params[0]} min={3} max={maxWidth} step={2}/>
   </Container>
   <Container label="Polynomial" id="{uid}-polynomial">
   <Select bind:value={params[1]} options={polOptions} />
   </Container>
   <Container label="Derivative" id="{uid}-derivative">
   <Select bind:value={params[2]} options={derOptions} />
   </Container>
</PrepTemplate>

